// The specialist page's Status card chips, shared by the specialist rows and Building
// readiness: the verdict, the stage, and who holds the top next action. The action
// itself is the first row of the Next actions table right below.
// See docs/Y2026-Q4/design-structured-next-actions-and-dates.md 7.2.
import type { PortfolioRow } from "../api/hooks/useAgentPortfolio";
import type { ProjectAgentStatusList } from "../api/hooks/useProjectAgentStatus";
import { LifecycleChip, OwnerChip, VerdictChip } from "./PortfolioRowParts";

/** A specialist's actions on the project, with the page they live on. */
export interface SpecialistLists {
  data: ProjectAgentStatusList;
  agent: string;
  projectId: string;
}

export const StatusCardChips = ({
  row,
  lists,
}: {
  row: PortfolioRow;
  /** Null while the actions load: the owner chip waits for them. */
  lists: SpecialistLists | null;
}) => {
  const move = lists?.data.agents.find((a) => a.agent === lists.agent)?.lists
    ?.next_move;
  return (
    <>
      {row.on_track?.verdict && <VerdictChip onTrack={row.on_track} />}
      <LifecycleChip lifecycle={row.lifecycle} />
      {lists && (
        <OwnerChip
          who={move?.who ?? "NOBODY"}
          lifecycle={row.lifecycle}
          overdueFrom={move?.overdue_from ?? ""}
          move={move}
        />
      )}
    </>
  );
};
